export default "__VITE_ASSET__DF$4YPvr__"